import React from 'react';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { IconSelect } from '@/hybrid/core/IconSelect.molecule';
import { getFormFieldProps, getFormFieldWrapperProps } from '@/hybrid/formbuilder/formbuilder.utilities';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import { FormFieldWrapper } from '@/hybrid/formbuilder/FormFieldWrapper';
import classNames from 'classnames';

export interface IconSelectIF extends ValidatingFormComponent<any> {
  component: 'IconSelectFormComponent';
  selectOptions: { text: string; value: any; icon?: string; label?: any }[];
  onChange: (option: { value: any }, property?: string) => void;
  onBlur?: any;
  formattedOptions?: boolean;
  placeholder?: string;
  testId?: string;
  insideModal?: boolean;
  appendToBody?: boolean;
  disabled?: boolean;
  wrapperClasses?: string;
  isMultipleSelect?: boolean;
  isSearchable?: boolean;
  onRemove?: (option: { value: any }) => void;
  // if true component will not be memoized. this should be used SPARINGLY. Should only be necessary if you need to
  // access state that would be stale if your component is memoized (see PeriodicCondition)
  skipMemo?: boolean;
  onTooltipClick?: () => void;
}

export const IconSelectFormComponent: React.FunctionComponent<IconSelectIF> = (props) => {
  const { name, validation, testId = 'iconSelect', wrapperClassNames } = props;

  const defaultValidation = _.isEmpty;
  const formState = useForm().getState();

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['wrapperClassNames', 'testId'])}
      testId={testId}
      wrapperClassNames={classNames('flexFill', wrapperClassNames)}>
      <Field name={name} validate={validation || defaultValidation}>
        {({ input, meta }) => (
          <IconSelect
            {...getFormFieldProps(formState, input, meta, props)}
            insideModal={true}
            testId={`${testId}Field`}
          />
        )}
      </Field>
    </FormFieldWrapper>
  );
};
